export const Roles = {
  SYSTEM_ADMIN: 'admin',
  CUSTOMER_ADMIN: 'event_manager',
  USER: 'user',
};
